/**
 * Merchant Outbound Return Item Table Columns
 */
const merchantOutboundReturnItemTableColumns = () => (
  [
    {
      Header  : 'Merchant Outbound Return Items',
      columns : [
        {
          Header         : 'ID',
          accessor       : 'id',
          disableFilters : true
        },
        {
          Header   : 'Inventory SKU',
          accessor : 'inventory_sku'
        },
        {
          Header         : 'Name',
          accessor       : 'name',
          disableFilters : true
        },
        {
          Header         : 'Category',
          accessor       : 'category',
          disableFilters : true
        },
        {
          Header         : 'Quantity',
          accessor       : 'quantity',
          disableFilters : true
        }
      ]
    }
  ]
)

export default merchantOutboundReturnItemTableColumns